import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { ArrowUpRight } from "lucide-react";
import { POPL_CARDS } from "@/config/social";

/**
 * Subtle single-line "Scan for digital card" row.
 * Renders two tiny QR codes side-by-side with brand-colored labels.
 */
export default function PoplRow() {
  const brands = [
    { key: "dtf", label: "Down To Film", url: POPL_CARDS.dtf, fg: "#0033A0" }, // DTF blue
    { key: "sc", label: "The Sticky Chick", url: POPL_CARDS.sc, fg: "#FF2FA8" }, // SC pink
  ];
  return (
    <section
      className="border-t-2 border-black bg-white"
      data-testid="popl-row-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <p className="label-mono text-[color:var(--muted-text)]">
          SCAN FOR OUR DIGITAL CARD ↓
        </p>
        <div className="flex flex-wrap items-center gap-6 md:gap-10">
          {brands.map((b) => (
            <a
              key={b.key}
              href={b.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 hover:opacity-90"
              data-testid={`popl-card-${b.key}`}
              aria-label={`${b.label} — open Popl digital card`}
            >
              <span className="border-2 border-black p-1.5 bg-white shrink-0">
                <QRCodeSVG
                  value={b.url}
                  size={56}
                  bgColor="#ffffff"
                  fgColor={b.fg}
                  level="M"
                  includeMargin={false}
                />
              </span>
              <span>
                <span className="label-mono block" style={{ color: b.fg }}>
                  {b.label}
                </span>
                <span className="font-mono text-xs text-[color:var(--muted-text)] inline-flex items-center gap-1 group-hover:text-black">
                  popl.co/{b.key === "dtf" ? "…/downtofilmapparel" : "…/thestickychick"}
                  <ArrowUpRight size={11} />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
